import sortBy from 'lodash-es/sortBy';
import sortedUniq from 'lodash-es/uniq';
import {
  ILoadable,
  IPYDatum,
  LoadableStatus,
} from '../../Utils';
import {
  getPYHash,
  IDeflatorsMap,
} from './internalUtils';

const createLookupTable = (inputStatus: ILoadable<IPYDatum[]>): ILoadable<IDeflatorsMap> => {
  let result: ILoadable<IDeflatorsMap>;
  if (inputStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (inputStatus.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (inputStatus.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: input} = inputStatus;
    const dataByProductYear: Map<string, IPYDatum> = new Map();
    const dataByYear: Map<number, number> = new Map();
    const allYears: number[] = [];
    for (const elem of input) {
      const {product_id, year} = elem;
      const key = getPYHash(product_id, year);
      dataByProductYear.set(key, elem);
      dataByYear.set(year, elem.deflator);
      allYears.push(year);
    }
    const distinctYears = sortedUniq(sortBy(allYears));


    result = {
      status: LoadableStatus.Present,
      data: {
        dataByProductYear,
        dataByYear,
        availableYears: new Set(distinctYears),
      },
    };
  }
  return result;
};

export default createLookupTable;
